module.exports = __webpack_public_path__ + "img/prize-02-icon.a526a3e4.png";